import { ReactNode, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import logUnableToUpgradeSubscription from '@alltrails/amplitude/events/logUnableToUpgradeSubscription';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import getHelpCenterUrl from '@alltrails/core/utils/getHelpCenterUrl';
import Dialog from '@alltrails/denali/components/Dialog';
import styles from './UnableToUpgradeDialog.module.scss';

type Props = {
  href?: string;
  onCloseRequest: () => void;
  text: ReactNode;
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=7670-29407&m=dev
export default function UnableToUpgradeDialog({ href, onCloseRequest, text }: Props) {
  const languageRegionCode = useLanguageRegionCode();

  useEffect(() => {
    logUnableToUpgradeSubscription();
  }, []);

  return (
    <Dialog
      body={<FormattedMessage defaultMessage="We’re having trouble upgrading your account" />}
      buttons={{
        primary: {
          linkInfo: {
            href: `${getHelpCenterUrl(languageRegionCode)}/requests/new`,
            target: '_blank'
          },
          text: <FormattedMessage defaultMessage="Contact support" />,
          testId: 'contact-support'
        },
        flat: {
          ...(href && { linkInfo: { href } }),
          onClick: () => {
            onCloseRequest();
          },
          text,
          testId: 'maybe-later'
        }
      }}
      onRequestClose={onCloseRequest}
      overlayClassName={styles.overlay}
      title={<FormattedMessage defaultMessage="Unable to upgrade" />}
    />
  );
}
